import React from "react";
import "react-tabs/style/react-tabs.css";
import "../../../stb_styles.css";
import RecentsList from "./RecentsList";
import { getSearchResultsByLimit } from "../../../resources/util/search";
import { DECISIONS_SEARCH_FOR_OPTION } from "../../../resources/constants/searches";
import { NETWORK_ERROR } from "../../../resources/constants/errors";
import { RESPONSE_DATA_SUBSET_FIELD } from "../../../resources/constants/api";
import Loading from "../../../scenes/Loading";

class Recents extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			searchFor: props.searchFor || DECISIONS_SEARCH_FOR_OPTION,
			searchCriteria: null,
			batchSize: 3,
			startIndex: 1,
			data: null
		};
		
		this.handleSaveData = this.handleSaveData.bind(this);

		getSearchResultsByLimit(this.state, this.handleSaveData);
	}

	handleSaveData = response => {
		this.setState({ data: response.data });
	};
	render() {
		if(!this.state.data) {
			return (
				<Loading/>
			);
		} else if(RESPONSE_DATA_SUBSET_FIELD in this.state.data) {
			return(
				<RecentsList
					searchFor={this.state.searchFor}
					data={this.state.data}
				/>
			);
		}
		else{
			return <h4 className="red-text">{NETWORK_ERROR}</h4>
		}
	}
}
export default Recents;
